import { useState, useEffect } from 'react';

const useVideoMetadata = (videoId) => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    if (!videoId) return;

    const fetchMetadata = () => {
      fetch(`https://youtube-data.365scores.com/?videoId=${videoId}`)
        .then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw new Error(`Failed to fetch video data. ${errorData.error.message}`);
            });
          }
          return response.json();
        })
        .then((data) => {
          if (data.error) {
            return Promise.reject(new Error(`API error: ${data.error.message}`));
          }

          if (data) {
            setMetadata({
              title: data.title,
              description:data.description,
              publishedAt: data.publishedAt,
              duration: formatDuration(Number(data.duration)),
            });
          } else {
            setMetadata(null); // If video not found
          }
        })
        .catch((err) => {
          setMetadata(null);  // Set metadata to null on error
        });
    };

    fetchMetadata();
  }, [videoId]);

  return metadata;  // Only return the metadata
};

export default useVideoMetadata;

const formatDuration = (seconds) => {
  if (!Number.isFinite(seconds) || seconds < 0) return null;

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  let duration = "PT";
  if (h > 0) duration += `${h}H`;
  if (m > 0) duration += `${m}M`;
  if (s > 0 || duration === "PT") duration += `${s}S`;

  return duration;
}

